module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("PULLMAN’S GEOLOGIC BEGINNINGS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ground at Pullman is today about eleven feet above the average current level of Lake Michigan. But Lake Michigan’s water level was originally much higher than today, and what is now Pullman spent thousands of years under the surface of that lake."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN1",
      "id": "FT1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lake Michigan was formed by glacial activities that gouged out the bottom of the lake and then deposited some of that eroded material in terminal moraines that parallel the shoreline of the southern part of the lake. The largest of these is called the Valparaiso Moraine. The high, rolling moraines then trapped the waters from the melting glacier, forming the beginnings of Lake Michigan. At various times since the lake’s formation about 14,500 years ago, the lake level has fallen—leaving the Pullman area above water—and then risen, inundating the area again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then about 4,700 years ago, the lake level stabilized long enough to form a beach about one half mile west of Pullman—just east of where Michigan Avenue now runs through the community of Roseland. The edge of that ancient shoreline is still visible when one travels west from Pullman on 111"), _c('sup', [_vm._v("th")]), _vm._v(" Street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the lake level dropped from the Michigan Avenue elevation, it left the former shoreline high above a relatively flat, low and marshy area between it and what later became Lake Calumet—then just a shallow inlet of Lake Michigan. Over the last two thousand years, much of this area, because of weather conditions, fluctuated between being soggy and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1870s found this region sparsely inhabited but close to the already prosperous community of Roseland to the west and to the Kensington railroad station development to the south. The area that would become the town of Pullman, then still outside of the city of Chicago, was nicely sandwiched between the Illinois Central Railroad and Lake Calumet, which was connected via the Calumet River to Lake Michigan. Thus, transportation of goods and people to and from the site by rail or eventually by water would not be a problem.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("All of the land shown here was under Lake Michigan when the lake was larger five thousand years ago. White areas near the state line indicate the dune and swale topography of the lower Tolleston shorelines, intermediate shades on the left are sand ridges and the dark area surrounding Lake Calumet was lake (Michigan) bottom land with clay-based soils. The small white area at the top is “Stony Island,” which was a stone reef similar to, but smaller than, the better-known one at Thornton. "), _c('i', [_vm._v("Schoon, 2003")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before development, much of the land gradually sloped downward toward Lake Calumet, whose shore was much closer to the Pullman area than it is now. Its clay soils were rather impermeable, causing rainwater to pond on the surface of the ground, creating in places a marshy, wet prairie landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the mid-nineteenth century, wetlands were not appreciated, and draining such areas was called “reclaiming” the land. In their natural state, these lands were considered worthless. They were often too wet to support either agriculture or physical development.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, one of the first things the Pullman company did was to dredge clay from the bottom of Lake Calumet (which was then only a few feet deep) and dump it on what would become the town site, thus raising the ground level of the low areas up to, perhaps, five feet above its natural elevation. With the underground sewers installed by the company, the ground dried out, allowing the plant and residential buildings to be built.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOLUTION OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLMAN AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URROUNDING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VER THE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARS AFTER")]), _vm._v(" 1890")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michigan Avenue and the ancient High Tolleston Shoreline are at the far left of each map.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kensington Station is at the bottom left of each map.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The black rectangles are large buildings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note how Lake Calumet has shrunk over the years.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center",
    attrs: {
      "id": "Page15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("1889")]), _vm._v(". Though this map has errors in building placement, it does show how close Lake Calumet was then to the town of Pullman. The “island” was the site of Pullman company’s boathouse and sporting events. "), _c('i', [_vm._v("United States Geological Survey (USGS).")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P15-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("1937")]), _vm._v(". White areas next to Lake Calumet are “made land,” created by the Pullman company as it needed more space. Roseland west of the IC tracks has been developed. "), _c('i', [_vm._v("USGS")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P15-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("1997")]), _vm._v(". Dark gray areas are city blocks filled with housing. The curving double line is Interstate 94. East of that highway and north of the lake is a Chicago sanitary landfill. Lake Calumet has been deepened and docking facilities built. "), _c('i', [_vm._v("USGS")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f41d7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 78
// module chunks = 0